import React from "react";
import classNames from "classnames";

const SubmitButton = (props) => (
    <button type="button"
            className={classNames("pure-button pure-button-primary", props.className)}
            onClick={props.onSubmit}
            disabled={props.disabled}
            style={{padding: "0.5em 1em"}}>{props.children}</button>
);
SubmitButton.propTypes = {
    className: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    onSubmit: React.PropTypes.func
};
SubmitButton.defaultProps = {
    disabled: false
};

export default SubmitButton;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/SubmitButton.js
 **/